// frontend/src/config/nodeConfig.js
export const NODE_FEATURES = {
  // === LITE NODES (Fully functional) ===
  trigger: { 
    lite: true,
    restrictions: {} // No restrictions for trigger in lite
  },
  
  aiModel: { 
    lite: true,
    restrictions: {} // No restrictions for AI model in lite
  },
  
  post: { 
    lite: true,
    restrictions: {} // Post node fully functional in lite
  },
  
  unsplash: { 
    lite: true,
    restrictions: {} // Unsplash fully functional in lite
  },
  
  research: { 
    lite: true,
    restrictions: {} // Research fully functional in lite
  },

  // === PARTIALLY RESTRICTED NODES ===
  chat: { 
    lite: true,
    restrictions: {
      lite: {
        lockedFeatures: ['actions', 'poweredByMenu'], // These specific features are locked
        lockedMessage: 'Advanced chat features are available in Pro'
      }
    }
  },
  
  output: { 
    lite: true,
    restrictions: {
      lite: {
        allowedTypes: ['display', 'save', 'html'], // display, database, shortcode
        lockedTypes: ['webhook', 'googleSheets', 'googleDrive'],
        lockedMessage: 'Advanced output types are Pro features'
      }
    }
  },

  // === ANNOTATION NODES (Always allowed) ===
  stickyNote: { lite: true, restrictions: {} },
  textAnnotation: { lite: true, restrictions: {} },
  shape: { lite: true, restrictions: {} },

  // === PRO-ONLY NODES (Completely locked) ===
  humanInput: { 
    lite: false,
    proMessage: 'Human Input nodes require Pro for workflow collaboration features'
  },
  
  sendEmail: { 
    lite: false,
    proMessage: 'Email automation requires Pro for business communication features'
  },
  
  condition: { 
    lite: false,
    proMessage: 'Conditional logic requires Pro for advanced workflow automation'
  },
  
  sentimentAnalysis: { 
    lite: false,
    proMessage: 'AI sentiment analysis is a Pro feature for advanced content insights'
  },
  
  summaryGenerator: { 
    lite: false,
    proMessage: 'AI summary generation is a Pro feature for content automation'
  },
  
  extractInformation: { 
    lite: false,
    proMessage: 'AI information extraction is a Pro feature for data processing'
  },
  
  writeArticle: { 
    lite: false,
    proMessage: 'AI article writing is a Pro feature for content automation'
  },
  
  optimizeSEO: { 
    lite: false,
    proMessage: 'SEO optimization is a Pro feature for content marketing'
  },
  
  parser: { 
    lite: false,
    proMessage: 'Data parsing requires Pro for advanced data processing workflows'
  },
  
  firecrawl: { 
    lite: false,
    proMessage: 'Web scraping requires Pro for data collection automation'
  },
  
  createFile: { 
    lite: false,
    proMessage: 'File creation requires Pro for document automation workflows'
  },
  
  APICall: { 
    lite: false,
    proMessage: 'API integrations require Pro for connecting external services'
  },
  
  mediaGenerator: { 
    lite: false,
    proMessage: 'Media generation requires Pro for multimedia content creation'
  },
  
  MCPClient: { 
    lite: false,
    proMessage: 'MCP Client requires Pro for advanced system integrations'
  }
};

// Helper functions
export const isNodeAllowedInLite = (nodeType) => {
  const config = NODE_FEATURES[nodeType];
  return config ? config.lite : false;
};

export const getNodeRestrictions = (nodeType) => {
  const config = NODE_FEATURES[nodeType];
  return config?.restrictions || {};
};

export const isFeatureLockedInLite = (nodeType, feature) => {
  const restrictions = getNodeRestrictions(nodeType);
  const liteRestrictions = restrictions.lite;
  
  if (!liteRestrictions) return false;
  
  return liteRestrictions.lockedFeatures?.includes(feature) || false;
};

export const isOutputTypeAllowed = (outputType) => {
  const restrictions = getNodeRestrictions('output');
  const liteRestrictions = restrictions.lite;
  
  if (!liteRestrictions) return true;
  
  return liteRestrictions.allowedTypes?.includes(outputType) || false;
};

export const getProMessage = (nodeType) => {
  const config = NODE_FEATURES[nodeType];
  return config?.proMessage || 'This is a Pro feature. Upgrade to unlock.';
};

export const getLiteRestrictionMessage = (nodeType) => {
  const restrictions = getNodeRestrictions(nodeType);
  return restrictions.lite?.lockedMessage || 'This feature requires Pro';
};